
import { DOCUMENT, Injectable, inject } from '@angular/core';

export interface TruncatedTextResult {
  plainTextLength: number;
  displayText: string;
  isTextTruncated: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class TextTruncationService {
  private document = inject<Document>(DOCUMENT);


  private stripHtmlTags(html: string): string {
    const tmp = this.document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  private cleanHtml(html: string): string {
    if (!html) return '';

    // First, remove empty paragraphs and break tags that have no content
    let cleaned = html
      // Remove empty paragraphs with only whitespace or breaks
      .replace(/<p[^>]*>(\s|<br\s*\/?>|&nbsp;)*<\/p>/gi, '')
      // Remove empty list items
      .replace(/<li[^>]*>(\s|<br\s*\/?>|&nbsp;)*<\/li>/gi, '')
      // Remove empty unordered lists
      .replace(/<ul[^>]*>(\s)*<\/ul>/gi, '')
      // Remove empty ordered lists
      .replace(/<ol[^>]*>(\s)*<\/ol>/gi, '');

    // Strip all remaining HTML tags to get plain text
    const plainText = this.stripHtmlTags(cleaned);

    // Return plain text without any HTML formatting
    return plainText.trim();
  }

  truncateText(text: string, maxLength: number, isExpanded: boolean): TruncatedTextResult {
    const plainText = this.stripHtmlTags(text);
    const plainTextLength = plainText.length;
    const needsTruncation = !isExpanded && plainTextLength > maxLength;

    return {
      plainTextLength,
      displayText: needsTruncation
        ? `<p>${plainText.substring(0, maxLength).concat('...')}</p>`
        : this.cleanHtml(text),
      isTextTruncated: needsTruncation
    };
  }
} 